import {showErrorSnackBar, showSuccessSnackBar} from "@/utils/SnackBartHelper";
import DocumentsService from "@/services/server/DocumentsService";
import {showDeleteDialogAlert} from "@/utils/DialogAlertHelper";

export default {
    name: 'DocumentsTab',
    data: () => ({
        documentsDataClickSign: [],
        file: null,
        savedDocs: [],
        isLoadingDocument: false,
        statusEnvelope: null,
        editingId: null,
        statusMapper: {
            draft: 'Rascunho',
            running: 'Em Progresso',
            canceled: 'Cancelado',
            closed: 'Totalmente Assinado',
        },
        headers: [
            {text: 'Nome do Arquivo', width: '250px', value: 'attributes.filename'},
            {text: 'Status', value: 'attributes.status', width: '150px'},
            {text: 'Assinantes Designados', width: '180px', value: 'attributes.metadata.totalSigners'},
            {text: 'Assinaturas Feitas', width: '155px', value: 'attributes.metadata.totalSigned'},
            {text: 'Ações', value: 'actions', width: '250px', sortable: false},
        ],
    }),
    computed: {
        getStatusEnvelope() {
            return this.envelopeStatus;
        },
        disabledByStatus() {
            return this.envelopeStatus === 'running' || this.envelopeStatus === 'draft'
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        param: {
            type: Array,
            default: () => ([])
        },
        idEnvelope: {
            type: String,
            default: null,
        },
        envelopeStatus: {
            type: String,
            default: null,
            required: true,
        },
    },
    methods: {
        getFileOptions(item) {
            return [
                {
                    label: "Arquivo Original",
                    doc_type: "original",
                    visible: item.links.files?.original
                },
                {
                    label: "Arquivo Assinado",
                    doc_type: "signed",
                    visible: item.links.files?.signed
                },
                {
                    label: "Arquivo Original e Assinado",
                    doc_type: "ziped",
                    visible: item.links.files?.ziped
                }
            ]
        },
        handleFileOption(option, item) {
            const fileOptions = {
                original: item.links.files?.original,
                signed: item.links.files?.signed,
                ziped: item.links.files?.ziped
            };
            
            window.open(fileOptions[option.doc_type]);
        },
        async emitSignatureFlowFirebase(newValue) {
            this.$emit('update-firebase-data', newValue);
        },
        wrapFilename(text) {
            if (text && text.length > 35) {
                return text.slice(0, 35) + '...'
            } else return text;
        },
        triggerFileInput() {
            this.$refs.fileInput.$el.querySelector('input').click();
        },
        async onFileChange() {
            if (this.file) {
                await this.processFiles(Array.isArray(this.file) ? this.file : [this.file]);
                this.file = null;
            }
        },
        checkSingleFile(files) {
            if (files.length > 1) {
                showErrorSnackBar("Apenas 1 documento por vez");
                return;
            }
        },
        async onDrop(event) {
            const files = event.dataTransfer.files;

            this.checkSingleFile(files);

            await this.processFiles(files);
        },
        async processFiles(files) {
            this.checkSingleFile(files);


            this.isLoadingDocument = true;
            this.savedDocs = []

            const file = files[0];

            const reader = new FileReader();
            reader.onload = async (e) => {
                const filename = file.name;

                const documentObject = {
                    filename: filename,
                    content_base64: e.target.result,
                    metadata: {
                        totalSigners: 0,
                        totalSigned: 0,
                        signersInfo: [],
                    }
                };

                try {
                    const result = await DocumentsService.createDocument(this.idEnvelope, documentObject)

                    this.documentsDataClickSign.push(result.data.data[0].data)
                    await this.emitSignatureFlowFirebase(result.data.data[1])

                    this.savedDocs.unshift({name: `${documentObject.filename.slice(0, 40)}...`})
                    showSuccessSnackBar("Documento inserido com sucesso!")
                } catch (error) {
                    showErrorSnackBar("Erro ao enviar documento");
                    console.error(error);
                } finally {
                    this.isLoadingDocument = false;
                }
            };

            reader.readAsDataURL(file);
        },
        async cancelDocument(item) {
            try {
                const result = await DocumentsService.cancelDocument(this.idEnvelope, item.id);

                this.documentsDataClickSign.forEach((doc) => {
                    if (doc.id === item.id) {
                        doc.attributes.status = "canceled"
                    }
                });

                showSuccessSnackBar("Documento cancelado com sucesso!")
            } catch (e) {
                console.error(e);
                showErrorSnackBar("Erro ao cancelar documento")
            }
        },
        async confirmCancelDocument(item) {
            showDeleteDialogAlert('Deseja mesmo cancelar esse documento?', (async () => this.cancelDocument(item)));
        },
        async deleteDocument(item) {
            try {
                const result = await DocumentsService.deleteDocument(this.idEnvelope, item.id);
                this.documentsDataClickSign = this.documentsDataClickSign.filter(doc => doc.id !== item.id);
                await this.emitSignatureFlowFirebase(result.data.data)
            } catch (e) {
                showErrorSnackBar("Erro ao cancelar documento")
                console.error(e);
            }
        },
        async confirmDelete(item) {
            showDeleteDialogAlert('Deseja mesmo deletar esse documento?', (async () => this.deleteDocument(item)));
        }
    },
    watch: {
        param: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.documentsDataClickSign = newValue
            }
        },
    }
}